import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

export const muiStyles = makeStyles((theme: typeof muiTheme) => ({
    headerContainer: { paddingBottom: '2.5rem' },
    headerText: {
        fontSize: '1rem',
        padding: '0 .5rem',
        '&:first-child': { paddingLeft: 0 }
    },
    buttonsContainer: { paddingRight: '2rem' },
    approvalButtonContainer: {
        width: 'auto' as 'auto',
        '&:first-child': { paddingRight: '2rem' },
        '&:last-child': { marginLeft: 0 }
    },
    approvalButtonMargin: { marginRight: '1.5rem' },
    detailSectionContainer: { paddingTop: '1.2rem' },
    detailSection: {
        width: '32%',
        minWidth: 'fit-content' as 'fit-content'
    },
    '@media (max-width: 1360px)': {
        detailSection: {
            width: '100%',
            margin: '0 55px 10px 27px'
        }
    },
    detailSectionHighlighted: { backgroundColor: theme?.app?.applicationColors.enumColors.offWhite || '#F3F3F3' },
    firmDetails: {
        minHeight: '40px',
        marginTop: '.25rem',
        padding: '.5rem .3rem',
        backgroundColor: theme?.app?.clientTheme.colors.highlightColor3 || '#B9D9EC'
    },
    firmAttribute: {
        fontSize: '1rem',
        fontWeight: 'bold' as 'bold',
        color: theme?.app?.applicationColors.enumColors.greyDark || '#333333'
    },
    cancelIcon: {
        position: 'absolute' as 'absolute',
        top: 18,
        right: 18
    },
    paperWidthXl: { width: '80%' },
    attribute: {
        fontSize: '.75rem',
        color: theme?.app?.applicationColors.enumColors.grey || '#888888',
        wordBreak: 'break-all' as 'break-all'
    },
    actionsButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(1),
        backgroundColor: '#4A90C2',
        color: '#fff',
        border: 'none',
        borderRadius: 6,
        padding: '14px',
        fontSize: '0.8rem',
        fontWeight: 'bold',
        letterSpacing: '0.5px',
        cursor: 'pointer',
        width: '110px',
        '&:hover': { backgroundColor: '#3f7fae' }
    },
    menuIcon: {
        color: '#fff',
        fontSize: '16px'
    },
    dropdownItem: {
        fontSize: '0.8rem',
        display: 'block',
        width: '110px',
        padding: '8px 0',
        textAlign: 'center',
        border: '1px solid #E0E0E0',
        cursor: 'pointer',
        transition: 'background 0.2s',
        background: '#FFF',
        '&:hover': { background: '#ECECEC' }
    },
    firstDropdownItem: {
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px'
    },
    lastDropdownItem: {
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
        boxShadow: '0 3px 3px rgba(30,30,30,0.3)'
    }
}));